import variables from './cssInJs/variables';
import firebase from 'firebase/app';
import 'firebase/auth';

const cssEmotion = {
  breakpointNames: variables.breakpointNames,
  breakpoints: variables.breakpoints
}

// Firebase configuration for push notifications
// TODO: Replace with your actual Firebase project configuration
const firebaseConfig = {
  apiKey: "AIzaSyCIAqN_OEjjNYKgYcRxWoDsbG1jv9xOtpE",
  authDomain: "adelaidefooty-dd4eb.firebaseapp.com", 
  projectId: "adelaidefooty-dd4eb",
  storageBucket: "adelaidefooty-dd4eb.appspot.com",
  messagingSenderId: "155304670865",
  appId: "1:155304670865:web:9b3004b31ee0fcf498b130"
};

/** Add Firebase ID token to requests when user is logged in (for CreateLiveFeedOrder, GetWatchLink, MyOrders, etc.). */
async function apiNetJwt(options) {
  const user = firebase.auth().currentUser;
  if (user) {
    const token = await user.getIdToken();
    options.headers = options.headers || {};
    options.headers['Authorization'] = `Bearer ${token}`;
  }
}

export default {
  cssEmotion,
  firebaseConfig,
  firebaseSettings: firebaseConfig,
  apiNetJwt
}